import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Linkedin, Mail } from 'lucide-react';
import Reveal from '../components/Reveal';
import { TEAM, COMPANY } from '../data/mock';

export default function Team() {
  return (
    <div className="bg-[var(--bg)]">
      <section className="pt-36 pb-16 border-b border-[var(--line)]">
        <div className="container-rs">
          <span className="section-index"><span className="coral-dot" /> 005 — The Board</span>
          <Reveal>
            <h1 className="font-display text-7xl md:text-[150px] leading-[0.92] mt-6">Our <span className="font-display-italic text-[var(--coral)]">people.</span></h1>
          </Reveal>
          <div className="grid md:grid-cols-12 gap-8 mt-10">
            <p className="md:col-span-7 md:col-start-6 text-[18px] md:text-[20px] text-[var(--ink-mute)] leading-relaxed">
              Bespoke is a business built on people. Founded in {COMPANY.established} by {COMPANY.founder}, our board brings together two-and-a-half decades of construction experience under one studio.
            </p>
          </div>
        </div>
      </section>

      <section className="py-20">
        <div className="container-rs grid md:grid-cols-2 lg:grid-cols-3 gap-10">
          {TEAM.map((m, i) => (
            <Reveal key={m.id} delay={(i % 3) * 80}>
              <div className="group">
                <div className="relative overflow-hidden rounded-2xl aspect-[4/5] bg-[var(--bg-soft)]">
                  <img src={m.image} alt={m.name} className="absolute inset-0 w-full h-full object-cover zoom-img" />
                  <div className="absolute bottom-4 left-4 right-4 flex gap-2">
                    <a href="#li" className="w-10 h-10 rounded-full bg-white/90 backdrop-blur flex items-center justify-center text-[var(--navy)] hover:bg-[var(--coral)] hover:text-white transition-colors" aria-label="LinkedIn"><Linkedin size={15} /></a>
                    <a href={`mailto:${COMPANY.email}`} className="w-10 h-10 rounded-full bg-white/90 backdrop-blur flex items-center justify-center text-[var(--navy)] hover:bg-[var(--coral)] hover:text-white transition-colors" aria-label="Email"><Mail size={15} /></a>
                  </div>
                </div>
                <div className="mt-6">
                  <div className="font-tag text-[var(--coral)]">{m.role}</div>
                  <h3 className="font-display text-3xl md:text-4xl mt-2">{m.name}</h3>
                  <p className="mt-3 text-[14px] text-[var(--ink-mute)] leading-relaxed">{m.bio}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="py-24 bg-[var(--navy)] text-white">
        <div className="container-rs flex flex-wrap items-center justify-between gap-10">
          <div className="font-display text-4xl md:text-6xl leading-tight max-w-2xl">Want to <span className="font-display-italic text-[var(--coral)]">join us?</span></div>
          <Link to="/careers" className="pill pill-coral"><span>Open Roles</span><ArrowUpRight size={14} /></Link>
        </div>
      </section>
    </div>
  );
}
